<template>
  <div class="capture" :class="type === 'evidence' ? 'full-img-width' : ''">
    <z-upload
      v-model="files"
      ref="upload"
      :max="max"
      isAdaptIosUplaod
      :weixin="weixin"
      :process-file="processFile"
      :uploadWeixinOptions="uploadWeixinOptions"
      @file-success="fileSuccess"
      @file-error="errHandler"
      @file-removed="fileRemoved"
    >
      <z-upload-file v-for="(file, i) in files" :file="file" :key="i" />
      <div class="camera">
        <z-upload-btn class="camera" v-if="showBtn">
          <div class="id-card" :class="type === 'evidence' ? 'full-width' : ''">
            <div
              class="sample-cover"
              :style="{ backgroundImage: 'url(' + $setPicSize(img) + ')' }"
            />
            <!-- <z-icon name="plus" size="24px" />
            <div class="id-card-warn">
              <div class="id-card-info">点击上传本人</div>
              <div class="id-card-info">身份证正面照</div>
            </div> -->
          </div>
        </z-upload-btn>
      </div>
    </z-upload>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { lego } from '@zz-common/lego'
import { Upload } from '@zz-common/zz-ui'
import compress from '@zz-common/zz-ui/lib/utils/image'
import setPicSize from '@zz-app/setPicSize'
import { tranUrl } from '../../../../lib/utils'

export default {
  name: 'SellerTip',
  props: {
    type: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    order: {
      type: String,
      default: ''
    },
    img: {
      type: String,
      default: 'n_v27754addf40324bd08c077a4ce8bbb045.png'
    }
  },
  data() {
    return {
      // action: { target: 'https://upload.58cdn.com.cn/json?rand=0.1928', zz: true },
      uploadWeixinOptions: { count: 1, sourceType: ['camera'] },
      accept: 'image/*',
      max: 1,
      weixin: true,
      zzapp: true,
      capture: true,
      files: []
    }
  },
  computed: {
    showBtn() {
      return this.max > this.files.length
    }
  },
  components: {
    zUpload: Upload,
    zUploadBtn: Upload.Btn,
    zUploadFile: Upload.File
    // zIcon: Icon
    // zButton: Button
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 600, 600)
    },
    fileSuccess(files) {
      try {
        const fileUrl = tranUrl(files.url)
        console.log('file.Url', files.url)
        console.log('fileUrls', fileUrl)
        this.$emit('uploaded', fileUrl, '', this.order)
      } catch (err) {
        this.legoError('fileSuccess', err.message)
      }
    },
    fileRemoved(_files) {
      console.log('fileRemoved')
      this.legoError('fileRemoved')
      this.$emit('uploaded', '', '', this.order)
    },
    errHandler(_file) {
      this.legoError('errHandler')
      console.log('Upload fail')
    },
    processFile(file, next) {
      compress(
        file,
        {
          compress: true // 开启图片压缩，提高上传的速度，同时修正图片方向修正的问题
        },
        next
      )
    },
    legoError(actiontype, reason = '') {
      lego.send({
        pagetype: 'ZZCLOUD_CAPTURE_UPLOAD',
        actiontype,
        backup: {
          reason
        }
      })
    }
  },
  mounted() {},
  beforeRouteEnter(_to, _from, next) {
    next((_vm) => {
      native.wrap('resetRightAllButton')()
    })
  }
}
</script>

<style lang="less">
  @import 'CaptureUpload.less';
</style>
